export default "__VITE_ASSET__DXsIPNX9__"